
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/cricket/[slug]/summary",
      function () {
        return require("private-next-pages/sports/cricket/[slug]/summary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/cricket/[slug]/summary"])
      });
    }
  